module.exports = __webpack_public_path__ + "img/daka_bg.73e6bce9.png";